import { useUserStore } from "@/store/user";
import { useRoute } from "vue-router";
import { computed, watch } from "vue";
import SubscribeRetainPop from "../NotRegisterComponents/SubscribeRetainPop.vue";
import { closeModalById, openModal } from "@/utils/modal";
import { TempRecordType, useTempRecordStore } from "@/store/tempRecord";

export function useRetainPopup() {
  const userStore = useUserStore();
  const route = useRoute();

  const SHOWN_KEY = "retainPopupShown";
  const tempRecordStore = useTempRecordStore();

  const isCancelSign = computed(() => userStore.sources.signStatus == "CANCEL_SIGN");

  const isHome = () => route.name == "workbench" || route.path == "/" || !route.name;

  /**
   * 取消订阅挽留弹窗显示
   */
  function applySubscribeRetain() {
    openModal(SubscribeRetainPop.modalId, {
      component: SubscribeRetainPop,
      props: {
        onClose: () => {
          closeModalById(SubscribeRetainPop.modalId);
        }
      }
    });

    tempRecordStore.setRecord(SHOWN_KEY, { popupId: SubscribeRetainPop.modalId }, TempRecordType.GLOBAL_ONCE);
  }

  // 路由变化时立即判断
  watch(
    () => route.name,
    () => {
      if (isHome()) return;
      if (isCancelSign.value) {
        if (!tempRecordStore.hasRecord(SHOWN_KEY)) {
          applySubscribeRetain();
        }
      } else if (!!userStore.userInfo.uniqueId) {
        tempRecordStore.removeRecord(SHOWN_KEY);
      }
    },
    { immediate: true }
  );
}
